export class APIError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
  }
}
let accountGeneration = 0;
export function invalidateAccountRequests() {
  accountGeneration++;
}
export async function api<T>(
  path: string,
  method = 'GET',
  body?: unknown,
  signal?: AbortSignal,
): Promise<T> {
  const generation = accountGeneration;
  if (method !== 'GET' && body === undefined) body = {};
  let response: Response;
  try {
    response = await fetch(`/api${path}`, {
      method,
      credentials: 'same-origin',
      signal,
      ...(body === undefined
        ? {}
        : { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }),
    });
  } catch (error) {
    if (signal?.aborted) throw error;
    throw new APIError('Cannot reach Terminal. Check the connection and try again.', 0);
  }
  const data = await response.json().catch(() => null);
  if (generation !== accountGeneration)
    throw new APIError('Your account changed. Please try again.', 409);
  if (
    response.status === 401 &&
    !path.startsWith('/auth/') &&
    path !== '/session' &&
    !path.startsWith('/invites/')
  )
    window.dispatchEvent(new Event('terminal:session-expired'));
  if (!response.ok)
    throw new APIError(
      data?.error?.message || `Request failed (${response.status}). Please try again.`,
      response.status,
    );
  return data as T;
}
export const errorMessage = (error: unknown) =>
  error instanceof Error ? error.message : 'Something went wrong. Please try again.';
